var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5890_46962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.15 0.640015C7.66684 0.640015 0.790039 7.51682 0.790039 16C0.790039 24.4832 7.66684 31.36 16.15 31.36C24.6332 31.36 31.51 24.4832 31.51 16C31.51 7.51682 24.6332 0.640015 16.15 0.640015ZM12.39 22.3664H9.27964V12.3568H12.39V22.3664ZM10.8156 11.128C9.83324 11.128 9.19804 10.432 9.19804 9.57121C9.19804 8.69281 9.85244 8.01761 10.8556 8.01761C11.8588 8.01761 12.4732 8.69281 12.4924 9.57121C12.4924 10.432 11.8588 11.128 10.8156 11.128ZM23.75 22.3664H20.6396V16.8192C20.6396 15.528 20.1884 14.6512 19.0636 14.6512C18.2044 14.6512 17.694 15.2448 17.4684 15.816C17.3852 16.0192 17.3644 16.3072 17.3644 16.5936V22.3648H14.2524V15.5488C14.2524 14.2992 14.2124 13.2544 14.1708 12.3552H16.8732L17.0156 13.7456H17.078C17.4876 13.0928 18.4908 12.1296 20.1692 12.1296C22.2156 12.1296 23.75 13.5008 23.75 16.448V22.3664Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5890_46962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinDark);
export default __webpack_public_path__ + "static/media/linkedin-dark.f481e109ee261e81acf9843dbee3a5fb.svg";
export { ForwardRef as ReactComponent };